module.exports = __webpack_public_path__ + "static/img/banner.cf1c7d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/company/banner.jpg
// module id = PGT2
// module chunks = 0